import React from 'react'
import { useProject } from 'shared'
import { AbCreateFundraisingEventButton } from '../create_fundraising_event_button'
import { AbSubscribeButton } from '../subscribe_button'

export type AbEngagementProps = {
  createFundraisingEventUrl: string
  newsletterSubscriptionUrl: string
  apiUrl: string
  fundraisingEventLandingpageUrl: string
  allowFundraisingEvents: string
}
export const AbEngagement = ({
  createFundraisingEventUrl,
  newsletterSubscriptionUrl,
  apiUrl,
  fundraisingEventLandingpageUrl,
  allowFundraisingEvents,
}: AbEngagementProps): JSX.Element => {
  const { status, ...project } = useProject(apiUrl)
  return (
    <div className="bg-gray-100">
      {/* Not mt-12 because component above (which we don't touch in this AB test already has margin bottom)  */}
      <div className="container mt-7">
        <div className="row">
          <div className="col-md-24">
            <h2 className="text-center mt-4 mb-4">
              {I18n.locale === 'de' ? 'Informiere und engagiere dich!' : 'Get informed and get involved'}
            </h2>
            <AbSubscribeButton project={project} url={newsletterSubscriptionUrl} />
            {allowFundraisingEvents === 'true' && (
              <AbCreateFundraisingEventButton
                ctaUrl={createFundraisingEventUrl}
                readmoreUrl={fundraisingEventLandingpageUrl}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
